import { MODAL_IDS } from '@/kit/Modal/keys';
import { useModal } from '@/providers/modal';
import { prettyDate } from '@/helpers/utils';
import { DATE_FORMAT_MMM_YYYY } from '@/helpers/common';
import { DateRangeModal } from '@/modals/DateRangeModal';
import Icon from './icon_chevron.svg';
import s from './index.module.scss';

export const MonthRangePickerMobile = ({ range = [null, null], ...props }) => {
  const { openSingleModal } = useModal();
  return (
    <>
      <button
        type="button"
        className={s.wrapper}
        onClick={() => openSingleModal(MODAL_IDS.date_range_modal)}
      >
        <span>
          {`${prettyDate(range[0], DATE_FORMAT_MMM_YYYY)} - ${prettyDate(range[1], DATE_FORMAT_MMM_YYYY)}`}
        </span>
        <img src={Icon} alt="icon" width={20} height={20} />
      </button>
      <DateRangeModal range={range} {...props} />
    </>
  );
};
